/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Muscles_Target_HeadlineInputs */

const en_us2_wrapped_muscles_target_headline = /** @type {(inputs: Wrapped_Muscles_Target_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`muscles on target`)
};

const pt_br2_wrapped_muscles_target_headline = /** @type {(inputs: Wrapped_Muscles_Target_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`músculos na meta`)
};

const es_419_wrapped_muscles_target_headline = /** @type {(inputs: Wrapped_Muscles_Target_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`músculos en la meta`)
};

const pt_pt2_wrapped_muscles_target_headline = /** @type {(inputs: Wrapped_Muscles_Target_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`músculos no objetivo`)
};

const fr_fr2_wrapped_muscles_target_headline = /** @type {(inputs: Wrapped_Muscles_Target_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`muscles dans l'objectif`)
};

const de_de2_wrapped_muscles_target_headline = /** @type {(inputs: Wrapped_Muscles_Target_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskeln im Ziel`)
};

const it_it2_wrapped_muscles_target_headline = /** @type {(inputs: Wrapped_Muscles_Target_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`muscoli in target`)
};

/**
* | output |
* | --- |
* | "muscles on target" |
*
* @param {Wrapped_Muscles_Target_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_target_headline = /** @type {((inputs?: Wrapped_Muscles_Target_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_Target_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_target_headline(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_target_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_target_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_target_headline(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_target_headline(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_target_headline(inputs)
	return en_us2_wrapped_muscles_target_headline(inputs)
});
export { wrapped_muscles_target_headline as "wrapped.muscles_target_headline" }